import { Component, OnInit, Input, EventEmitter, Output, SimpleChanges, OnChanges } from '@angular/core';
import { NgSelectComponent } from '@ng-select/ng-select'
import { I18NextPipe } from 'angular-i18next';

@Component({
    selector: 'app-widget-select',
    templateUrl: './widget-select.component.html',
    styleUrls: ['./widget-select.component.scss'],
    standalone: false
})
export class WidgetSelectComponent implements OnInit, OnChanges {

  @Input() items: Array<any>;
  @Input() bindLabel: string;
  @Input() bindValue: string;
  @Input() placeholder: string = "Select";
  @Input() translateItems: boolean = false;
  @Input() translationNamespace: string = "dashboard";
  @Input() model: any;
  @Output() modelChange = new EventEmitter<any>();
  @Input() title: string;
  @Input() appendTo: string = null;
  isOpen: boolean;
  isFiltered: boolean = false;
  filteredItems: Array<any>;
  restrictedItems: any;

  constructor(private i18nextPipe: I18NextPipe) { }

  get isAllItemsSelected(): boolean {
    return this.items?.length + this.restrictedItems?.length == this.model?.length;
  }

  get isAllFilteredItemsSelected(): boolean {
    return this.isFiltered && this.filteredItems?.every(i => this.model?.indexOf(i[this.bindValue]) > -1);
  }

  onSearch($event) {
    this.isFiltered = $event.term.length > 0;
    this.filteredItems = $event.items;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.items && this.model) {
      let itemIds = this.items.map((i) => i[this.bindValue]);
      this.restrictedItems = this.model.filter((v) => { return !itemIds.includes(v); });
    }
  }

  ngOnInit(): void { }

  selectAll(ngSelectControl: NgSelectComponent) {
    let model = [...this.model ?? []];
    if (this.isFiltered && !this.isAllFilteredItemsSelected) {
      this.filteredItems?.forEach(element => {
        if (model.indexOf(element[this.bindValue]) == -1) {
          model.push(element[this.bindValue]);
        }
      });
    } else if (this.isFiltered && this.isAllFilteredItemsSelected) {
      this.filteredItems?.forEach(element => {
        let index = model.indexOf(element[this.bindValue]);
        if (index > -1) {
          model.splice(index, 1);
        }
      });
    } else if (!this.isAllItemsSelected) {
      model = this.items.map(p => p[this.bindValue]);
    }
    else {
      model = [];
      this.restrictedItems?.forEach(element => {
        model.push(element);
      });
    }
    this.model = model;
    this.modelChange.emit(this.model);
  }

  itemText(id: number) {
    let item = this.items?.find((i) => i[this.bindValue] == id)
    return item ? item[this.bindLabel] : '';
  }

  itemExists(id: number) {
    return this.items?.find((i) => i[this.bindValue] == id) != undefined;
  }

  clearItem(ngSelectControl: NgSelectComponent, id: number) {
    ngSelectControl.clearItem(this.items?.find((i) => i[this.bindValue] == id));
  }

  customSearchFn = (term: string, item: any) => {
    let name = item[this.bindLabel];
    if (this.translateItems) {
      name = this.i18nextPipe.transform(this.translationNamespace + ':' + name)
    }
    return name.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) > -1;
  }
}
